<template>
  <UiContainer class="relative flex flex-col">
    <header v-if="isMdAndDown && activeVenue">
      <UiButtonLink
        :tag="AppRouterLink"
        icon
        :to="{ name: 'VenueView', params: { id: activeVenue.id } }"
        class="!mb-3 block gap-1 !text-2xl font-semibold md:w-fit"
      >
        {{ activeVenue.title }}
      </UiButtonLink>
    </header>
    <UiTitle v-else severity="h3" class="mb-3">Карта</UiTitle>
    <section v-if="!loading && value">
      <div class="relative !max-w-full !p-0">
        <VenueYandexMap
          v-model:active-venue="activeVenue"
          :value="uniqueVenues"
          :static="isLgAndDown"
          :height="isLgAndDown ? '56vh' : '496px'"
          class="z-0 max-h-[450px] w-full overflow-hidden rounded-none lg:rounded-2xl"
        />
      </div>
      <div v-if="isLgAndDown && uniqueVenues.length > 1">
        <SelectVenueInList
          v-model:active-venue="activeVenue"
          :value="uniqueVenues"
          class="relative z-10"
        />
      </div>
    </section>
    <template v-else>
      <EventVenuesSkeleton />
    </template>
  </UiContainer>
</template>

<script setup lang="ts">
import type { Nullable } from 'ts-helpers'
import { computed, shallowRef, watch } from 'vue'
import { SelectVenueInList } from '@/4_features/Venue'
import type { Event } from '@/5_entities/Event'
import { type Venue, VenueYandexMap } from '@/5_entities/Venue'
import { useBreakpoint } from '@/6_shared/lib'
import { AppRouterLink, UiButtonLink, UiContainer, UiTitle } from '@/6_shared/ui'
import EventVenuesSkeleton from './EventVenuesSkeleton.vue'

type PropType = {
  value?: Event
  loading?: boolean
}

const props = withDefaults(defineProps<PropType>(), {
  loading: false,
  value: undefined
})
const {
  md: [_isMdAndUp, isMdAndDown],
  lg: [_isLgAndUp, isLgAndDown]
} = useBreakpoint()
const uniqueVenues = computed(
  (): Venue[] =>
    (props.value &&
      props.value.venues.reduce((acc, item) => {
        if (!acc.find((venue) => venue.id === item.id)) acc.push(item)

        return acc
      }, [] as Venue[])) ||
    []
)

watch(
  () => uniqueVenues.value,
  (val) => {
    val.length && (activeVenue.value = val[0])
  },
  {
    once: true
  }
)

const activeVenue = shallowRef<Nullable<Venue>>(null)
</script>
